import {ApDynformsConfigBase, ApDynformsControltype} from './ap-dynforms-config-base';
import {EventEmitter}                   from '@angular/core';
import {Observable}                                  from 'rxjs';

/**
 * configuration for dynForm element which allows inserting buttons in a dynForm
 */
export class ApDynformsConfigButton extends ApDynformsConfigBase<string> {
  public controlType = ApDynformsControltype.Button;
  public callback: EventEmitter<any>;
  public disabledButton$: Observable<boolean>;

  constructor(options: {
    key?: string,
    value?: string,
    cssClass?: string,
    disabledButton$?: Observable<boolean>,
    icon?: string,
    callback?: EventEmitter<any>
  } = {}) {
    super(options);
    this.callback = options.callback;
    this.disabledButton$ = options.disabledButton$;
    this.cssClass = options.cssClass ? options.cssClass : 'ap-dynform-element-center';
  }
}

